import { UniformsLib, UniformsUtils } from "three";
import { GLOBAL_UNIFORMS } from "../../shader/GlobalUniforms";
//  glslify is used for including GLSL shader code
const glslify = require("glslify");
const VERTEX_SHADER = require("./particle.vert");
const FRAGMENT_SHADER = require("./particle.frag");
const INSTANCE_VERTEX_SHADER = VERTEX_SHADER && glslify(VERTEX_SHADER);
const INSTANCE_FRAGMENT_SHADER = FRAGMENT_SHADER && glslify(FRAGMENT_SHADER);
export var ParticleAttributes;
(function (ParticleAttributes) {
    ParticleAttributes[ParticleAttributes["position"] = 0] = "position";
    ParticleAttributes[ParticleAttributes["offset"] = 1] = "offset";
})(ParticleAttributes || (ParticleAttributes = {}));
export const PARTICLE_INSTANCE_SHADER = {
    uniforms: UniformsUtils.merge([
        /* we need at least some of these to use threes fragments and not get undefined errors */
        UniformsLib.common,
        UniformsLib.lights,
        {
            cameraCenterWorldPosition: { value: {} },
            platformScale: { value: {} },
            time: { value: {} },
            alpha: { value: 1.0 },
            minY: { value: 0 },
            noiseTexture: { value: {} },
            uParticleSize: { value: 0.01 },
            uMaxParticleDistance: { value: 10 }
        }
    ]),
    vertexShader: INSTANCE_VERTEX_SHADER,
    fragmentShader: INSTANCE_FRAGMENT_SHADER,
    attributes: [
        // position in room coordinates
        {
            name: "particlePosition",
            size: 3,
            type: Float32Array,
            normalized: false
        },
        { name: "aNoiseOffset", size: 4, type: Float32Array, normalized: false }
    ]
};
// UniformsUtils.merge() will clone the uniform,
// but we want some of the uniform use the some objects
// therefore we have to override some uniforms.
PARTICLE_INSTANCE_SHADER.uniforms.cameraCenterWorldPosition = GLOBAL_UNIFORMS.cameraCenterWorldPosition;
PARTICLE_INSTANCE_SHADER.uniforms.platformScale = GLOBAL_UNIFORMS.platformScale;
PARTICLE_INSTANCE_SHADER.uniforms.time = GLOBAL_UNIFORMS.time;
PARTICLE_INSTANCE_SHADER.uniforms.noiseTexture = GLOBAL_UNIFORMS.noiseTexture;
